/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdDomainSettingsAdvertisementWeChatOptions interface.
 */
export function instanceOfFxIdDomainSettingsAdvertisementWeChatOptions(value) {
    if (!('DisableFallbackSharePage' in value) || value['DisableFallbackSharePage'] === undefined)
        return false;
    return true;
}
export function FxIdDomainSettingsAdvertisementWeChatOptionsFromJSON(json) {
    return FxIdDomainSettingsAdvertisementWeChatOptionsFromJSONTyped(json, false);
}
export function FxIdDomainSettingsAdvertisementWeChatOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'RewardedVideoAdId': json['RewardedVideoAdId'] == null ? undefined : json['RewardedVideoAdId'],
        'InterstitialAdId': json['InterstitialAdId'] == null ? undefined : json['InterstitialAdId'],
        'DisableFallbackSharePage': json['DisableFallbackSharePage'],
    };
}
export function FxIdDomainSettingsAdvertisementWeChatOptionsToJSON(json) {
    return FxIdDomainSettingsAdvertisementWeChatOptionsToJSONTyped(json, false);
}
export function FxIdDomainSettingsAdvertisementWeChatOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'RewardedVideoAdId': value['RewardedVideoAdId'],
        'InterstitialAdId': value['InterstitialAdId'],
        'DisableFallbackSharePage': value['DisableFallbackSharePage'],
    };
}
//# sourceMappingURL=FxIdDomainSettingsAdvertisementWeChatOptions.js.map